import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";

var backfillOldData = function backfillOldData(_this) {
  var acctBsbInfo = _.cloneDeepGet(_this, "oppBusiData.oldBusiData.acctBsbInfo");
  if (!_.isEmpty(acctBsbInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], acctBsbInfo);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var acctBsbInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  var acctBsbInfo2 = _.cloneDeepGet(_this.historyData, SAVE_PATH2);
  if (!_.isEmpty(acctBsbInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], acctBsbInfo);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], acctBsbInfo);
  }
  if (!_.isEmpty(acctBsbInfo2)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], acctBsbInfo2);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], acctBsbInfo2);
  }
};

var setFeildData = function setFeildData(fieldData, fieldAction, val, filterArr) {
  _.each(fieldData, function (item) {
    if (filterArr.indexOf(item.FIELD_ID) == -1) {
      item[fieldAction] = val;
    };
  });
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  fields.BSB_ID_TYPE.FIELD_DICT_NAME = _.filter(fields.BSB_ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "1";
  });

  _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_SAME_LICENSE.FIELD_TYPE = "radio";
  _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_SAME_LICENSE.isLongItem = true;

  if (_this.userType == "2") {
    _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_PRO_TRUSTEE_INFO.FIELD_TYPE = "radio";
    _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_PRO_TRUSTEE_INFO.isLongItem = true;

    if (_this.groupDatas.OTHER_INFO_PAGE.PRO_TRUSTEE_INFO[0].FIELDS.IS_PRO_TRUSTEE.DEFAULT_VALUE == "1") {
      _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_PRO_TRUSTEE_INFO.FIELD_CONTROL = "0";
    } else {
      _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_PRO_TRUSTEE_INFO.FIELD_CONTROL = "1";
    }
  } else {
    _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_SAME_LICENSE.FIELD_TITLE = "是否同机构三要素";
  }

  if (_this.userType == "2") {
    _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_SAME_LICENSE.isLongItem = false;
    _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_PRO_TRUSTEE_INFO.FIELD_TYPE = "radio";
    _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_PRO_TRUSTEE_INFO.isLongItem = false;

    _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_SAME_LICENSE.DEFAULT_VALUE = "0";
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);

    if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
      backfillOldData(_this);
    }
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var bsbInfo, oldBsbInfo, oldBsbInfo2, IS_SAME_LICENSE;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              bsbInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH], true);
              oldBsbInfo = _.get(params, "" + SAVE_PATH);
              ;
              oldBsbInfo2 = _.get(params, "" + SAVE_PATH2);
              IS_SAME_LICENSE = bsbInfo.IS_SAME_LICENSE;

              delete bsbInfo["IS_SAME_LICENSE"];

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], bsbInfo);

              _.set(params, SAVE_PATH, _Object$assign({}, oldBsbInfo, bsbInfo));
              _.set(params, SAVE_PATH2, _Object$assign({}, oldBsbInfo2, { IS_SAME_LICENSE: IS_SAME_LICENSE }));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {

    if (_this.userType == "2") {
      var proTrusteeInfoObj = _this.groupDatas["OTHER_INFO_PAGE"]["PRO_TRUSTEE_INFO"][0].FIELDS;

      if (proTrusteeInfoObj.IS_PRO_TRUSTEE.DEFAULT_VALUE != "1") {
        _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_SAME_LICENSE.isLongItem = true;
      } else {
        _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_SAME_LICENSE.isLongItem = false;
        _this.groupDatas.ACCT_INFO.BSB_MODULE[0].FIELDS.IS_PRO_TRUSTEE_INFO.FIELD_CONTROL = "0";
      }
    }

    for (var mdId in _this.moduleDatas) {

      if (mdId == "BSB_MODULE") {
        var md = _this.moduleDatas[mdId][0];
        var fieldData = md.FIELDS;
        var field = fieldData.IS_SAME_LICENSE;

        _this.busiLogic.CHECK_IS_SAME_LICENSE(_this, field, fieldData, md, true);

        var field2 = fieldData.IS_PRO_TRUSTEE_INFO;
        if (field2) {
          _this.busiLogic.CHECK_IS_PRO_TRUSTEE_INFO(_this, field2, fieldData, md, true);
        }
      }
    }
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},

  "CHECK_IS_SAME_LICENSE": function CHECK_IS_SAME_LICENSE(_this, field, fieldData, md, noClean) {

    if (!field.DEFAULT_VALUE) {
      return;
    }

    if (field.DEFAULT_VALUE == "1") {
      if (_this.userType != "2") {
        fieldData.BSB_USER_FNAME.DEFAULT_VALUE = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.CUST_FNAME.DEFAULT_VALUE;
      } else {
        fieldData.IS_PRO_TRUSTEE_INFO.DEFAULT_VALUE = "0";
      }
      fieldData.BSB_ID_TYPE.DEFAULT_VALUE = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_TYPE.DEFAULT_VALUE;
      fieldData.BSB_ID_CODE.DEFAULT_VALUE = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_CODE.DEFAULT_VALUE;
      fieldData.BSB_ID_EXP_DATE.DEFAULT_VALUE = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_EXP_DATE.DEFAULT_VALUE;
      if (_this.userType == "1") {
        setFeildData(fieldData, "FIELD_CONTROL", "1", _this.userType == "2" ? ["BSB_USER_FNAME", "IS_SAME_LICENSE", "IS_PRO_TRUSTEE_INFO"] : ["IS_SAME_LICENSE"]);
      }
    } else {
      if (_this.userType == "1") {
        setFeildData(fieldData, "FIELD_CONTROL", "0", ["IS_SAME_LICENSE", "IS_PRO_TRUSTEE_INFO"]);
      }
    }

    if (_this.userType == "2") {
      if (field.DEFAULT_VALUE != "" && fieldData.IS_PRO_TRUSTEE_INFO.DEFAULT_VALUE != "") {
        if (field.DEFAULT_VALUE == "0" && fieldData.IS_PRO_TRUSTEE_INFO.DEFAULT_VALUE == "0") {
          setFeildData(fieldData, "FIELD_CONTROL", "0", ["IS_SAME_LICENSE", "IS_PRO_TRUSTEE_INFO"]);
        } else {
          setFeildData(fieldData, "FIELD_CONTROL", "1", _this.userType == "2" ? ["BSB_USER_FNAME", "IS_SAME_LICENSE", "IS_PRO_TRUSTEE_INFO"] : ["IS_SAME_LICENSE"]);
        }
      }
    }
  },

  "CHECK_IS_PRO_TRUSTEE_INFO": function CHECK_IS_PRO_TRUSTEE_INFO(_this, field, fieldData, md, noClean) {
    if (!field.DEFAULT_VALUE) {
      return;
    }

    var proTrusteeInfoObj = _this.groupDatas["OTHER_INFO_PAGE"]["PRO_TRUSTEE_INFO"][0].FIELDS;
    if (proTrusteeInfoObj.IS_PRO_TRUSTEE.DEFAULT_VALUE != "1") {
      field.FIELD_CONTROL = "1";
      return;
    }

    if (field.DEFAULT_VALUE == "1") {
      fieldData.IS_SAME_LICENSE.DEFAULT_VALUE = "0";

      !noClean && (fieldData.BSB_USER_FNAME.DEFAULT_VALUE = "");
      fieldData.BSB_ID_TYPE.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.PRO_TRUSTEE_INFO[0].FIELDS.PRO_TRUSTEE_ID_TYPE.DEFAULT_VALUE;
      fieldData.BSB_ID_CODE.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.PRO_TRUSTEE_INFO[0].FIELDS.PRO_TRUSTEE_ID_CODE.DEFAULT_VALUE;
      fieldData.BSB_ID_EXP_DATE.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.PRO_TRUSTEE_INFO[0].FIELDS.PRO_TRUSTEE_ID_EXP_DATE.DEFAULT_VALUE;
    }
    if (_this.userType == "2") {
      if (field.DEFAULT_VALUE != "" && fieldData.IS_SAME_LICENSE.DEFAULT_VALUE != "") {
        if (field.DEFAULT_VALUE == "0" && fieldData.IS_SAME_LICENSE.DEFAULT_VALUE == "0") {
          setFeildData(fieldData, "FIELD_CONTROL", "0", ["IS_SAME_LICENSE", "IS_PRO_TRUSTEE_INFO"]);
        } else {
          setFeildData(fieldData, "FIELD_CONTROL", "1", _this.userType == "2" ? ["BSB_USER_FNAME", "IS_SAME_LICENSE", "IS_PRO_TRUSTEE_INFO"] : ["IS_SAME_LICENSE"]);
        }
      }
    }
  },
  "CHECK_BSB_ID_TYPE": function CHECK_BSB_ID_TYPE(_this, field, fieldData, md) {
    fieldData["BSB_ID_CODE"] && (fieldData["BSB_ID_CODE"].VALID_TYPE = _this.$blMethod.getIdCodeValidType(field.DEFAULT_VALUE));
  }

};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizAcct/bizAcctBsbInfoNode.js
// module id = 165
// module chunks = 2